import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetalleApartamentoComponent } from './detalle-apartamento/detalle-apartamento.component';
import { DetalleEspacioComponent } from './detalle-espacio/detalle-espacio.component';
import { PaginaLugaresComponent } from './pagina-espacios/pagina-lugares.component';

const rutas: Routes = [
  { path: '', component: PaginaLugaresComponent },
  { path: 'apartamentos/:id', component: DetalleApartamentoComponent },
  { path: 'detalle-espacio/:id', component: DetalleEspacioComponent },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild( rutas )
  ],
  exports: [
    RouterModule
  ]
})

export class LugaresRoutingModule { }
